/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import PostProvider from 'app/redux/Providers/PostProvider.jsx';
import PostPreview from 'app/components/common/PostPreview.jsx';
import ProcessingModal from 'app/components/common/ProcessingModal.jsx';
import RouteDetailModule from 'app/mixins/RouteDetailModule.jsx';
import RouteDetailSocials from 'app/components/RouteList/RouteDetailSocials.jsx';
import SocialButton from 'app/components/common/SocialButton.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import UserMessageModule from 'app/modules/UserMessageModule.js';
import * as _ from 'underscore';
import { compose } from 'redux';
import { PostActions, InputActions, RouteActions } from 'app/redux/actions.js';
import Utilities from 'app/utility/Utilities.js';
import { Breakpoint } from 'react-socks';

class SimpleRouteItemDetail extends React.Component {
	constructor(props) {
		super(props);

		this.editInput = this.editInput.bind(this);
		this.refreshInput = this.refreshInput.bind(this);
		this.viewInput = this.viewInput.bind(this);
		this.viewHistory = this.viewHistory.bind(this);
		this.viewMedic = this.viewMedic.bind(this);
		this.deleteInput = this.deleteInput.bind(this);
		this.repostMethod = this.repostMethod.bind(this);

	}

	componentDidMount() {

		if (this.props.route.lastPost !== undefined && this.props.route.lastPost.piID !== undefined) {
			this.props.getPostPreview(this.props.route.lastPost.piID, this.props.route.lastPost.pipID);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {

		if (this.props.route.lastPost !== undefined && this.props.route.lastPost.piID !== undefined &&
			prevProps.route.lastPost !== undefined && prevProps.route.lastPost.piID !== this.props.route.lastPost.piID) {
			this.props.getPostPreview(this.props.route.lastPost.piID, this.props.route.lastPost.pipID);
		}

	}

	editInput(event) {
		if (this.props.route.inputs.length) {
			this.props.router.navigate('/share/automate/detail/' + this.props.route.id + '/input/' + this.props.route.inputs[0].id);
		}
	}

	refreshInput(e) { // && this.props.route.inputs[0].activeFlag === 1
		if (this.props.route.inputs.length) {
			this.props.refreshInput(this.props.route.inputs[0].id);
		}
	}

    viewInput(e) {
        let constants = this.props.app.config.constants,
            url = '';

		if (this.props.route.inputs.length) {
			url = this.props.route.inputs[0].resource;

			if (url) {
				if (this.props.route.inputs[0].type === constants.INPUT_TYPE_FEED) {
		                    url = '/feedPreview.php?url=' + encodeURIComponent(url) +  (this.props.route.inputs[0].useCachebuster !== undefined && this.props.route.inputs[0].useCachebuster === true ? '&cb=1' : '') ;
		        }

		        let win = window.open(url, "_blank");

				if (win) {
		            win.focus();
		        }
			}
		}

    }


	viewHistory(e) {
		if (this.props.route.inputs.length) {
			this.props.router.navigate('/share/automate/detail/' + this.props.route.id + '/input/' + this.props.route.inputs[0].id + '/status');
		}
	}

	viewMedic(e) {
		if (this.props.route.inputs.length) {
			this.props.router.navigate('/share/automate/detail/' + this.props.route.id + '/input/' + this.props.route.inputs[0].id + '/medic');
		}
	}

	deleteInput(e) {

		let cancelAction = () => {
				this.props.closeAllModals();
			},
			confirmAction = (e) => {
				let modal = (
					<ProcessingModal
						modalCopy="Please wait while we delete your input."
						modalLabel="Deleting"
						closeAction={cancelAction} />
				);

				e.preventDefault();
				this.props.addModal(modal);
				this.props.deleteRoute(this.props.route.id);
				this.props.router.navigate('/share/automate');
			},
			modal = (
				<DeleteModal
					modalCopy="Are you sure you want to remove this feed?"
					cancelAction={cancelAction}
					confirmAction={confirmAction} />
			);

		this.props.addModal(modal);

	}

	repostMethod(item) {
		this.props.persistData('repostItem', item);
		this.props.router.navigate('/content/post');
	}

	render() {
		let statusBlock = null,
			Preview = null,
			lastPost = 0,
			previewKey = 0,
			activeFlag = (parseInt(this.props.route.activeFlag, 10) !== 0) ? true : false,
			viewButton = null,
			constants = this.props.app.config.constants,
			reconnectButton = null,
			detailBlock = null,
			buttons = {
				toggle: null,
				view: null,
				reconnect: null,
				settings: null,
				refresh: null,
				history: null,
				medic: null,
				delete: null
			};

		// the route detail info hasn't been loaded yet
		if (!this.props.route.inputs) {
			return null;
		}

		// consider the activeFlag state of the input as well
		if (parseInt(this.props.route.inputs[0].activeFlag, 10) === 0 || this.props.route.inputs[0].activeFlag === false) {
			activeFlag = false;
		}

		if (this.props.route.lastPost && this.props.route.lastPost.postTs) {
			previewKey = this.props.route.lastPost.piID;
			lastPost = moment(this.props.route.lastPost.postTs).tz(this.props.user.detail.timezone).format();
		}

		Preview = (
			<PostPreview
				{...this.props}
				context="route"
				postInfo={this.props.posts.preview}
				postTime={lastPost}
				repostMethod={this.repostMethod} />
		);

		statusBlock = this.props.generateDetailStatusBlock.apply(this, [this.props.route.inputs[0]]);

		if (this.props.reactivating) {
			if (this.props.reactivatingInput) {
				detailBlock = this.props.getReactivateBlock('input');
			} else {
				detailBlock = this.props.getReactivateBlock('route');
			}

		} else {
			detailBlock = (
				<div>
					{statusBlock}
					<RouteDetailSocials
						{...this.props}
						route={this.props.route}
						routeId={this.props.route.id}
						outputs={this.props.route.outputs}
						routeActive={activeFlag}
						outputConfigHandler={this.configureOutput}
						recordPath={this.props.recordPath} />
					<div className="post-history">
						<div className="last-detail-posted">
							{Preview}
						</div>
					</div>
				</div>
			);
		}

		buttons.toggle = (
			<div className="detail-toggle">
				<ToggleControl active={activeFlag} callback={this.props.activeRouteToggleClick}/>
			</div>
		);

		buttons.settings = (
			<div className="detail-button" onClick={this.editInput} role="button" aria-label="settings">
				<div className="button-icon">
					<i className="fa fa-pencil"></i>
				</div>
				<div className="button-label">
					Settings
				</div>
			</div>
		);

		buttons.refresh = (
			<div className="detail-button" onClick={this.refreshInput} role="button" aria-label="refresh">
				<div className="button-icon">
					<i className="fa fa-refresh"></i>
				</div>
				<div className="button-label">
					Refresh
				</div>
			</div>
		);

		buttons.history = (
			<div className="detail-button" onClick={this.viewHistory} role="button" aria-label="view history">
				<div className="button-icon">
					<i className="fa fa-history"></i>
				</div>
				<div className="button-label">
					History
				</div>
			</div>
		);

		buttons.medic = (
			<div className="detail-button" onClick={this.viewMedic} role="button" aria-label="run feed medic">
				<div className="button-icon">
					<i className="fa fa-stethoscope"></i>
				</div>
				<div className="button-label">
					Medic
				</div>
			</div>
		);

		buttons.delete = (
			<div className="detail-button" onClick={this.deleteInput} role="button" aria-label="delete">
				<div className="button-icon">
					<i className="fa fa-trash"></i>
				</div>
				<div className="button-label">
					Delete
				</div>
			</div>
		);

		//if (this.props.route.inputs[0].type != constants.INPUT_TYPE_TWITTER) {
			buttons.view = (
				<div className="detail-button" onClick={this.viewInput} role="button" aria-label="preview">
					<div className="button-icon">
						<i className="fa fa-external-link"></i>
					</div>
					<div className="button-label">
						Preview
					</div>
				</div>
			);
		//}

		if ([
				constants.INPUT_TYPE_TWITTER,
				constants.INPUT_TYPE_INSTAGRAM,
				constants.INPUT_TYPE_INSTAGRAM_BUSINESS,
				constants.INPUT_TYPE_FACEBOOK_PAGE,
				constants.INPUT_TYPE_TIKTOK
			].indexOf(this.props.route.inputs[0].type) !== -1) {
			let reconnect = '';
			if (this.props.route.inputs[0].sysActionFlag !== undefined && this.props.route.inputs[0].sysActionFlag === true) {
				reconnect = 'error';
			}
			buttons.reconnect = (
				<div className="detail-button" onClick={this.props.reauthorizeInput} data-id={this.props.route.inputs[0].id} data-serviceid={this.props.route.inputs[0].type} role="button" aria-label="reconnect">
					<div className="button-icon">
						<i className={`fa fa-refresh ${reconnect}`}></i>
					</div>
					<div className={`button-label ${reconnect}`}>
						Reconnect
					</div>
				</div>
			);
		}

		return (
			<div>
				<Breakpoint desktop only>
					<div className="detail-controls">
						{buttons.toggle}
						<div className="detail-buttons">
							{buttons.settings}
							{buttons.refresh}
							{buttons.view}
							{buttons.reconnect}
							{buttons.history}
							{buttons.medic}
							{buttons.delete}
						</div>
					</div>
				</Breakpoint>
				<Breakpoint mobile only>
					<div className="detail-controls mobile">
						<div className="detail-control-row">
							{buttons.toggle}
							{buttons.reconnect}
							{buttons.delete}
						</div>
						<div className="detail-control-row">
							{buttons.settings}
							{buttons.refresh}
							{buttons.view}
							{buttons.history}
							{buttons.medic}
						</div>
					</div>
				</Breakpoint>
				{detailBlock}
			</div>
		);
	}

};

SimpleRouteItemDetail.displayName = "SimpleRouteItemDetail";

const enhance = compose(
	PostProvider,
	SubscriptionModule,
	RouteDetailModule
);

export default enhance(SimpleRouteItemDetail);
